import Cookies from 'js-cookie'
import { getSysConfigById } from '@/api/system'
const app = {
  state: {
    sidebar: {
      opened: Cookies.get('sidebarStatus') ? !!+Cookies.get('sidebarStatus') : true,
      withoutAnimation: false
    },
    device: 'desktop',
    language: Cookies.get('language') || 'en',
    size: Cookies.get('size') || 'medium',
    formula: '',
    formula2: ''
  },
  mutations: {
    TOGGLE_SIDEBAR: state => {
      state.sidebar.opened = !state.sidebar.opened
      state.sidebar.withoutAnimation = false
      if (state.sidebar.opened) {
        Cookies.set('sidebarStatus', 1)
      } else {
        Cookies.set('sidebarStatus', 0)
      }
    },
    CLOSE_SIDEBAR: (state, withoutAnimation) => {
      Cookies.set('sidebarStatus', 0)
      state.sidebar.opened = false
      state.sidebar.withoutAnimation = withoutAnimation
    },
    TOGGLE_DEVICE: (state, device) => {
      state.device = device
    },
    TOGGLE_FORMULA: (state, formula) => {
      state.formula = formula
    },
    TOGGLE_FORMULA2: (state, formula) => {
      state.formula2 = formula
    },
    SET_LANGUAGE: (state, language) => {
      state.language = language
      Cookies.set('language', language)
    },
    SET_SIZE: (state, size) => {
      state.size = size
      Cookies.set('size', size)
    },

  },
  actions: {
    toggleSideBar({ commit }) {
      commit('TOGGLE_SIDEBAR')
    },
    closeSideBar({ commit }, { withoutAnimation }) {
      commit('CLOSE_SIDEBAR', withoutAnimation)
    },
    toggleDevice({ commit }, device) {
      commit('TOGGLE_DEVICE', device)
    },
    setLanguage({ commit }, language) {
      commit('SET_LANGUAGE', language)
    },
    setFormula({ commit }) {
      getSysConfigById({ id: 20 }).then(res => {
      commit('TOGGLE_FORMULA',  res.data.data || {id: 20, name: "", key: ""} )
      })
      getSysConfigById({ id: 21 }).then(res => {
      commit('TOGGLE_FORMULA2',  res.data.data || {id: 21, name: "", key: ""})
      })
    },
    setSize({ commit }, size) {
      commit('SET_SIZE', size)
    },
  }
}

export default app
